import { accentTextStyles } from '@/components/common/accent-text';

/**
 * Interpret colors in a string and wrap them in a span with a class
 * @param title - The string to interpret
 * @returns The interpreted string
 */
export const interpretColors = (title: string): string => {
  const orange = title.match(
    /orange:([^\s]*?)(?=\s|$|orange:|red:|underline:)/g,
  );
  const red = title.match(/red:([^\s]*?)(?=\s|$|orange:|red:|underline:)/g);
  const underline = title.match(
    /underline:([^\s]*?)(?=\s|$|orange:|red:|underline:)/g,
  );

  if (orange) {
    orange.forEach((match) => {
      const word = match.replace('orange:', '');
      title = title.replace(
        match,
        `<span class='text-brand-yellow'>${word}</span>`,
      );
    });
  }

  if (underline) {
    underline.forEach((match) => {
      const word = match.replace('underline:', '');
      title = title.replace(
        match,
        `<span class='${accentTextStyles}'>${word}</span>`,
      );
    });
  }

  if (red) {
    red.forEach((match) => {
      const word = match.replace('red:', '');
      title = title.replace(
        match,
        `<span class='text-brand-red'>${word}</span>`,
      );
    });
  }

  return title;
};
